import EntityPermissionsConstants from "../constants/constants";


export const clearEntityPermissions = { type: EntityPermissionsConstants.CLEAR_ENTITY_PERMS };

export const clearActorsFetching = { type: EntityPermissionsConstants.CLEAR_ACTORS_FETCHING };

export const clearActorsWithBanedUsers = { type: EntityPermissionsConstants.CLEAR_USERS_WITH_BANED_USERS };
